import { Box, Container, Paper, Typography } from "@mui/material";

function ContentLayout({ children, title, actions }) {
  return (
    <Box sx={{ py: 3 }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
          {actions && <Box>{actions}</Box>}
        </Box>
        <Paper
          elevation={2}
          sx={{
            p: 3,
            minHeight: "calc(100vh - 200px)",
          }}
        >
          {children}
        </Paper>
      </Container>
    </Box>
  );
}

export default ContentLayout;
